// extracted by mini-css-extract-plugin
module.exports = {"container":"part-other-services_container__iHEQi","title":"part-other-services_title__bbdEb","servicesList":"part-other-services_servicesList__hXR_2"};